var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"z-index":"998","value":_vm.controller.requesting}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"32"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }